// Typelizer digest 275ca6d1852bda7454b8cf2b2b2a2e6b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /educators/teachers/:teacher_id/relief/invitations */
  create: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/invitations', params, options),
    method: 'post',
  }),

  /** GET /educators/teachers/:teacher_id/relief/invitations/new */
  new: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/invitations/new', params, options),
    method: 'get',
  }),

  /** GET /educators/relief/invitations/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/relief/invitations/:id', params, options),
    method: 'get',
  }),

  /** PATCH /educators/relief/invitations/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/relief/invitations/:id', params, options),
    method: 'patch',
  }),
}
